import { z } from 'zod/v4';

import { UserDTORuntype } from '../user';

export type AvlScopeSourceDTO = z.infer<typeof AvlScopeSourceRuntype>;
export const AvlScopeSourceRuntype = z.union([
    z.object({
        type: z.literal('System'),
    }),
    z.object({
        type: z.literal('User'),
        value: UserDTORuntype.pick({ id: true, first_name: true, last_name: true, email: true }).nullable(),
    }),
]);

export type ScopeResponseDTO = z.infer<typeof ScopeResponseRuntype>;
export const ScopeResponseRuntype = z.union([
    z.object({
        id: z.string(),
        type: z.literal('Manufacturer'),
        value: z.string(),
        source: AvlScopeSourceRuntype,
    }),
    z.object({
        id: z.string(),
        type: z.literal('PartCategory'),
        value: z.number(),
        source: AvlScopeSourceRuntype,
    }),
    z.object({
        id: z.string(),
        type: z.literal('CustomPartCategory'),
        value: z.string(),
        source: AvlScopeSourceRuntype,
    }),
]);

export type ScopeRequestDTO = z.infer<typeof ScopeRequestRuntype>;
export const ScopeRequestRuntype = z.union([
    z.object({ type: z.literal('Manufacturer'), value: z.string() }),
    z.object({ type: z.literal('PartCategory'), value: z.number() }),
    z.object({ type: z.literal('CustomPartCategory'), value: z.string() }),
]);

export interface SupplierAvlScopesDTO extends z.infer<typeof SupplierAvlScopesDTORuntype> {}
export const SupplierAvlScopesDTORuntype = z.object({
    supplier: z.string(),
    scopes: z.array(ScopeResponseRuntype),
});

export const SupplierApprovedVendorListPatchDTORuntype = z.object({
    scopes: z.array(ScopeRequestRuntype),
});
